// @ts-check

/** @param {string} param */
export function searchUrlParam(param) {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) || null;
}

export function getSourceClick() {
  const clickIds = ['gclid', 'fbclid', 'ttclid', 'msclkid', 'twclid', 'wbraid', 'gbraid'];

  for (const source of clickIds) {
    const value = searchUrlParam(source);
    if (value) {
      return {
        source_click_id: value,
        source_click_type: source,
      };
    }
  }

  return {
    source_click_id: '',
    source_click_type: '',
  };
}

/**
 * The session the external Analytics script publishes on `window.JLG.analytics`. Empty strings
 * until it has loaded — there is no server value that could seed it.
 */
export function readSession() {
  const session = window.JLG?.analytics?.session;

  return {
    sessionId: session?.session_id ?? '',
    visitorId: session?.visitor_id ?? '',
  };
}

/**
 * The campaign `lib/marketing/index.js` mirrors onto `window.JLG.marketing`, in one shape with
 * one set of defaults. Every vendor reports the same values under its own key names, and reading
 * them here is what keeps those reports from disagreeing.
 */
export function readAttribution() {
  const marketing = window.JLG?.marketing;

  return {
    campaignId: marketing?.campaign?.id ?? 0,
    offerId: marketing?.offer?.id ?? 0,
    leadTypeId: marketing?.lead_type?.id ?? 0,
    leadTypeName: marketing?.lead_type?.name ?? '',
    leadSource: marketing?.lead_source?.type?.name ?? 'Unknown',
  };
}

/** @param {string} name */
export function getCookie(name) {
  if (!window) {
    return;
  }
  const cookie = window?.document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));

  return cookie ? cookie.split('=')[1] : null;
}

/**
 * @param {string} key
 * @param {string} value
 */
export function setCookie(key, value) {
  const oneYear = 365 * 24 * 60 * 60;

  document.cookie =
    `${key}=${value}` + `; Path=/` + `; Max-Age=${oneYear}` + `; SameSite=Lax` + `; Secure`;
}
